import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { NavLink as Link } from 'react-router-dom';
import config from 'config';
import ListManagementInfo from 'app/components/ListManagementInfo';
import { getLeadAutomatorPlanDetails, getPlansTypeAPI } from 'data/user/actions';
import { selectUserId, selectPlanDetails } from 'data/user/selectors';
import { isLaAvailable } from 'utils/brand';

import css from './style.scss';


class ListAutomatorPopover extends PureComponent {

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }
 componentDidMount() {
    const { userId, getLeadAutomatorPlanDetails,getPlansTypeAPI } = this.props;
    if (userId) {
      getLeadAutomatorPlanDetails(userId);
      getPlansTypeAPI(userId);
    }
  }

  handleClick(ev) {
    const { checkSavedProperty } = this.props;
    const { target: form } = ev;
    const { constants: { API: { BASE_URL } } } = config;

    ev.preventDefault();
    ev.stopPropagation();

    checkSavedProperty((id) => {
      form.action = `${BASE_URL}/resource/auth/ps4/user/properties/${id}/bluebook/directaccess/url?redirect=true`;
      form.submit();
    });
  }

  render() {
    const { className, openListManagementInfo } = this.props;
    return !isLaAvailable() ? null : (
      <div className={classNames(css.lmOverlay, className)}>
        <div className={classNames(css.lmUpgrade)}>
          <p className={css.infoText}>Additional Filtering Requires PropStream Connect</p>
            <Link 
              to={"/accountnew/leadautomator"} 
              className={css.link} 
              style={  {}}
            >
                Learn More
            </Link>
        </div>
      </div>
    );
  }
}

ListAutomatorPopover.propTypes = {
  className: PropTypes.string,
};

export default connect(state => ({
    userId: selectUserId(state)
  }), {
      openListManagementInfo: ListManagementInfo.open, 
      getLeadAutomatorPlanDetails,
      getPlansTypeAPI
    }
)(ListAutomatorPopover);
